import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitColumnsExtensionInterface } from '../../../extension/interface/benefit-columns.extension.interface';
import { BenefitInfoTextExtensionInterface } from '../../../extension/interface/benefit-info-text.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { RecreationBenefitActivationDialogExtension } from './extension/recreation-benefit-activation-dialog.extension';
import { RecreationBenefitColumnsExtension } from './extension/recreation-benefit-columns.extension';
import { RecreationBenefitInfoTextExtension } from './extension/recreation-benefit-info-text.extension';
import { RecreationBenefitMetadataExtension } from './extension/recreation-benefit-metadata.extension';
import { RecreationBenefitNavigationExtension } from './extension/recreation-benefit-navigation.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('recreation')
    .add(BenefitMetadataExtensionInterface, new RecreationBenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new RecreationBenefitNavigationExtension())
    .add(BenefitColumnsExtensionInterface, new RecreationBenefitColumnsExtension())
    .add(BenefitActivationDialogExtensionInterface, new RecreationBenefitActivationDialogExtension())
    .add(BenefitInfoTextExtensionInterface, new RecreationBenefitInfoTextExtension())
    .build(),
);
